import React from 'react';
import { createRoot } from 'react-dom/client';

// If your tailwind CSS is loaded through this SCSS file, keep this import:
import './assets/css/main.css'; 

// Import your Configurator component
import Configurator from './pages/Configurator';

// Find the target div on your WordPress page
const targetElement = document.getElementById('pc-configurator-root');

// Render the app directly without any routers or stores
if (targetElement) {
    const root = createRoot(targetElement);
    root.render(
        <React.StrictMode>
            <Configurator />
        </React.StrictMode>
    );
}